// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"e2860ad1","783":"0f1f170a"}[chunkId] + ".chunk.css";
};